import {Component} from '@angular/core';


import { InformationService} from '../services/information.service';

import {DomSanitizer} from '@angular/platform-browser';


@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.css'],
    providers: [ InformationService ]
})
export class TimelineComponent {
    label : string;
    subtitle : string;
    entries: any[] = [];

    constructor(private informationService: InformationService, private sanitizer:DomSanitizer){
        this.label = "Where I came from?";
        this.subtitle = "A timeline for my profesional career.";
    };

    ngOnInit() {
        this.informationService.getTimeline().subscribe(response => {this.entries = response.json()});
    }

    sanitize(url:string){
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
};